export const PROJECT_NAME = 'approvals'
